<template>
    <div>
        <el-dialog title="提交报名" custom-class="apply-job-dialog" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :visible="dialogVisible" @close="afterCloseInitFun" width="1145px">
            <div class="main-cont">

                <!-- ① 岗位信息（置顶） -->
                <div class="model-box job-info-box">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>应聘岗位信息</div>
                        </div>
                        <div class="model-title-btn">
                            <el-button
                                :icon="toggle_model.job_detail_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('job_detail_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="job-info-grid" v-if="toggle_model.job_detail_toggle">
                        <div class="job-info-item">
                            <span class="job-info-label">岗位代码</span>
                            <span class="job-info-value">{{ job_detail.nameOfSuperiorUnit || '—' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">所在区域</span>
                            <span class="job-info-value">{{ job_detail.regionName || '—' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">单位名称</span>
                            <span class="job-info-value">{{ job_detail.nameOfEmployer || '—' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">岗位类别</span>
                            <span class="job-info-value">{{ job_detail.jobCategory || '—' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">招聘人数</span>
                            <span class="job-info-value highlight">{{ job_detail.recruitingNum || '—' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">年龄要求</span>
                            <span class="job-info-value">{{ job_detail.ageRequirements || '—' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">学历要求</span>
                            <span class="job-info-value">{{ (!job_detail.educationalRequirements || job_detail.educationalRequirements === '不限') ? '不限' : job_detail.educationalRequirements + '及以上' }}{{ job_detail.allowTechnicianClassRelax == 1 ? '（含技工院校技师（预备技师）班毕业生）' : '' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">学位要求</span>
                            <span class="job-info-value">{{ (!job_detail.academicDegree || job_detail.academicDegree === '无') ? '无' : job_detail.academicDegree + '及以上' }}</span>
                        </div>
                        <div class="job-info-item">
                            <span class="job-info-label">职称要求</span>
                            <span class="job-info-value">{{ (!job_detail.professionalTitleRequirements || job_detail.professionalTitleRequirements === '无') ? '无' : job_detail.professionalTitleRequirements + '及以上' }}</span>
                        </div>
                        <div class="job-info-item job-info-item--wide">
                            <span class="job-info-label">专业名称</span>
                            <span class="job-info-value">{{ job_detail.professionalName || '—' }}</span>
                        </div>
                        <div class="job-info-item job-info-item--wide">
                            <span class="job-info-label">专业三级目录限制要求</span>
                            <span class="job-info-value">{{ job_detail.professionalRequirements || '—' }}</span>
                        </div>
                        <div class="job-info-item job-info-item--wide" v-if="job_detail.otherRequirements">
                            <span class="job-info-label">岗位其他要求</span>
                            <span class="job-info-value">{{ job_detail.otherRequirements }}</span>
                        </div>
                        <div class="job-info-item job-info-item--wide" v-if="job_detail.remark">
                            <span class="job-info-label">备注</span>
                            <span class="job-info-value">{{ job_detail.remark }}</span>
                        </div>
                        <div class="job-info-item" v-if="job_detail.contactInfo">
                            <span class="job-info-label">联系电话</span>
                            <span class="job-info-value">{{ job_detail.contactInfo }}</span>
                        </div>
                    </div>
                </div>

                <!-- ② 基本信息 -->
                <div class="model-box" ref="base_area">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>基本信息</div>
                        </div>
                        <div class="model-title-btn">
                            <el-button
                                :icon="toggle_model.base_info_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('base_info_toggle')"></el-button>
                        </div>
                    </div>
                    <el-form ref="base_form" :model="form" :rules="rules" label-width="85px">
                        <div class="model-box-cont" v-if="toggle_model.base_info_toggle">

                            <!-- 文字录入区 -->
                            <div class="base-fields-grid">
                                <div class="base-field-item">
                                    <el-form-item label="姓名:" prop="name">
                                        <el-input v-model="form.name" size="small"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item">
                                    <el-form-item label="手机号:" prop="phone">
                                        <el-input v-model="form.phone" size="small"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('emergency_contact_phone')">
                                    <el-form-item label="紧急联系人电话:" prop="emergency_contact_phone">
                                        <el-input v-model="form.emergency_contact_phone" size="small"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('sex')">
                                    <el-form-item label="性别:" prop="sex">
                                        <el-select v-model="form.sex" size="small" style="width:100%">
                                            <el-option v-for="(item, index) in sexOptions" :key="index" :label="item.label" :value="item.value" />
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('birthday')">
                                    <el-form-item label="出生日期:" prop="birthday">
                                        <el-date-picker v-model="form.birthday" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" size="small" style="width:100%" />
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('nation')">
                                    <el-form-item label="民族:" prop="nation">
                                        <el-select v-model="form.nation" size="small" style="width:100%">
                                            <el-option v-for="(item, index) in nationOptions" :key="index" :label="item.label" :value="item.value" />
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('politice_status')">
                                    <el-form-item label="政治面貌:" prop="politice_status">
                                        <el-select v-model="form.politice_status" size="small" style="width:100%">
                                            <el-option v-for="(item, index) in politiceOptions" :key="index" :label="item.label" :value="item.value" />
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('college_place')">
                                    <el-form-item label="生源地:" prop="college_place">
                                        <el-cascader v-model="form.college_place" :options="provinceCityCountryData" separator='-' size="small" style="width:100%"></el-cascader>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item">
                                    <el-form-item label="学历:" prop="educational_level">
                                        <el-select v-model="form.educational_level" size="small" style="width:100%">
                                            <el-option v-for="(item, index) in educationaleOptions" :key="index" :label="item.label" :value="item.value" />
                                        </el-select>
                                        <div v-if="job_detail.allowTechnicianClassRelax == 1" class="field-tip">
                                            <span>是否技工院校技师（预备技师）班毕业生：</span>
                                            <el-radio-group v-model="form.is_technician_class_graduate">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="0">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item">
                                    <el-form-item label="学位:" prop="academic_degree">
                                        <el-select v-model="form.academic_degree" size="small" style="width:100%">
                                            <el-option v-for="(item, index) in degreeOptions" :key="index" :label="item.label" :value="item.value" />
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('professional_title_level')">
                                    <el-form-item label="职称等级:" prop="professional_title_level">
                                        <el-select v-model="form.professional_title_level" size="small" placeholder="请选择职称等级" style="width:100%">
                                            <el-option v-for="(item, index) in professionalTitleOptions" :key="index" :label="item.label" :value="item.value" />
                                        </el-select>
                                        <div v-if="job_detail.allowSeniorTitleRelax == 1 && (form.professional_title_level === '副高级' || form.professional_title_level === '正高级')"
                                             class="field-tip">
                                            该岗位支持副高及以上职称放宽学历至本科，请在下方上传职称证书照片
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('contact_address')">
                                    <el-form-item label="省市区:" prop="region">
                                        <el-cascader v-model="form.region" :options="provinceCityCountryData" separator='-' size="small" style="width:100%"></el-cascader>
                                    </el-form-item>
                                </div>
                                <div class="base-field-item" v-if="isFieldVisible('native_place')">
                                    <el-form-item label="籍贯:" prop="native_place">
                                        <el-cascader v-model="form.native_place" :options="provinceCityCountryData" separator='-' size="small" style="width:100%"></el-cascader>
                                    </el-form-item>
                                </div>
                                <!-- 身份证号跨两列 -->
                                <div class="base-field-item base-field-item--span2">
                                    <el-form-item label="身份证号:" prop="IdNum">
                                        <el-input v-model="form.IdNum" size="small"></el-input>
                                    </el-form-item>
                                </div>
                                <!-- 联系地址跨两列 -->
                                <div class="base-field-item base-field-item--span2" v-if="isFieldVisible('contact_address')">
                                    <el-form-item label="联系地址:" prop="address">
                                        <el-input v-model="form.address" size="small"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <!-- 证件照片上传区 -->
                            <div class="photo-upload-section" v-if="isFieldVisible('id_card_img') || isFieldVisible('near_photo')">
                                <div class="photo-section-title">
                                    <span class="photo-section-line"></span>
                                    <span class="photo-section-text">证件照片上传</span>
                                    <span class="photo-section-line"></span>
                                </div>
                                <div class="photo-upload-row">
                                    <div class="photo-upload-item" v-if="isFieldVisible('id_card_img')">
                                        <el-form-item label-width="0" prop="ID_img_front">
                                            <div class="photo-label" :class="{ 'required-label': isFieldRequired('id_card_img') }">身份证正面照</div>
                                            <upload-img ref="ID_img_front" filed="ID_img_front" isSingle :callFun="sendUpload"></upload-img>
                                        </el-form-item>
                                    </div>
                                    <div class="photo-upload-item" v-if="isFieldVisible('id_card_img')">
                                        <el-form-item label-width="0" prop="ID_img_back">
                                            <div class="photo-label" :class="{ 'required-label': isFieldRequired('id_card_img') }">身份证反面照</div>
                                            <upload-img ref="ID_img_back" filed="ID_img_back" isSingle :callFun="sendUpload"></upload-img>
                                        </el-form-item>
                                    </div>
                                    <div class="photo-upload-item" v-if="isFieldVisible('near_photo')">
                                        <el-form-item label-width="0" prop="near_photo">
                                            <div class="photo-label" :class="{ 'required-label': isFieldRequired('near_photo') }">近期一寸免冠彩色照片</div>
                                            <upload-img ref="near_photo" filed="near_photo" isSingle :callFun="sendUpload"></upload-img>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </el-form>
                </div>

                <!-- ③ 高中 -->
                <div class="model-box " ref="child_high_area" v-if="form.qualification_high_list.length > 0">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>高中</div>
                            <div class="notice-box">
                              1.获得单个学历的人员只需填写一个即可；2.获得多个学历的人员，可点击 "<span>添加明细</span>"继续补充；<br>3.尚未发放毕业证的应届毕业生，需上传所在院校出具的毕业相关证明。
                            </div>
                        </div>
                        <div class="model-title-btn">
                            <el-button type="primary" size="mini" plain
                                @click="addChildItemFun('qualification_high')">添加明细</el-button>
                            <el-button
                                :icon="toggle_model.education_high_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('education_high_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="model-box-cont" v-if="toggle_model.education_high_toggle">
                        <educationCard ref="qualification_high_list"
                            v-for="(item, index) in form.qualification_high_list" :key="index" :form="item"
                            :index="index + 1" filed="qualification_high_list" :degree_cert="false" :chsi_cert="false"
                            @removeCall="delChildItemFun">
                        </educationCard>
                    </div>
                </div>

                <!-- ④ 大专 -->
                <div class="model-box " ref="child_college_area" v-if="form.qualification_college_list.length > 0">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>大专</div>
                            <div class="notice-box">
                              1.获得单个学历的人员只需填写一个即可；2.获得多个学历的人员，可点击 "<span>添加明细</span>"继续补充；<br>3.尚未发放毕业证的应届毕业生，需上传所在院校出具的毕业相关证明。
                            </div>
                        </div>
                        <div class="model-title-btn">
                            <el-button type="primary" size="mini" plain
                                @click="addChildItemFun('qualification_college')">添加明细</el-button>
                            <el-button
                                :icon="toggle_model.education_college_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('education_college_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="model-box-cont" v-if="toggle_model.education_college_toggle">
                        <educationCard ref="qualification_college_list"
                            v-for="(item, index) in form.qualification_college_list" :key="index" :form="item"
                            :index="index + 1" filed="qualification_college_list" :degree_cert="false"
                            @removeCall="delChildItemFun">
                        </educationCard>
                    </div>
                </div>

                <!-- ⑤ 本科 -->
                <div class="model-box " ref="child_bs_area" v-if="form.qualification_bs_list.length > 0">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>本科</div>
                            <div class="notice-box">
                              1.获得单个学位的人员只需填写一个即可；2.获得多个学位的人员，可点击 "<span>添加明细</span>"继续补充；<br>3.尚未发放毕业证的应届毕业生，需上传所在院校出具的毕业相关证明。
                            </div>
                        </div>
                        <div class="model-title-btn">
                            <el-button type="primary" size="mini" plain
                                @click="addChildItemFun('qualification_bs')">添加明细</el-button>
                            <el-button
                                :icon="toggle_model.education_bs_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('education_bs_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="model-box-cont" v-if="toggle_model.education_bs_toggle">
                        <educationCard ref="qualification_bs_list" v-for="(item, index) in form.qualification_bs_list"
                            :key="index" :form="item" :index="index + 1" filed="qualification_bs_list"
                            @removeCall="delChildItemFun">
                        </educationCard>
                    </div>
                </div>

                <!-- ⑥ 研究生 -->
                <div class="model-box " ref="child_grad_area" v-if="form.qualification_grad_list.length > 0">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>研究生</div>
                            <div class="notice-box">
                              1.获得单个学位的人员只需填写一个即可；2.获得多个学位的人员，可点击 "<span>添加明细</span>"继续补充；<br>3.尚未发放毕业证的应届毕业生，需上传所在院校出具的毕业相关证明。
                            </div>
                        </div>
                        <div class="model-title-btn">
                          <el-button type="primary" size="mini" plain
                                     @click="addChildItemFun('qualification_grad')">添加明细</el-button>
                          <el-button
                              :icon="toggle_model.education_grad_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                              size="mini" circle @click="toggleModelFun('education_grad_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="model-box-cont" v-if="toggle_model.education_grad_toggle">
                        <educationCard ref="qualification_grad_list"
                            v-for="(item, index) in form.qualification_grad_list" :key="index" :form="item"
                            :index="index + 1" filed="qualification_grad_list"
                            :show_overseas="job_detail.enableOverseasRestriction == 1"
                            @removeCall="delChildItemFun">
                        </educationCard>
                    </div>
                </div>

                <!-- ⑦ 博士 -->
                <div class="model-box " ref="child_scholar_area" v-if="form.qualification_scholar_list.length > 0">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>博士</div>
                            <div class="notice-box">
                              1.获得单个学位的人员只需填写一个即可；2.获得多个学位的人员，可点击 "<span>添加明细</span>"继续补充；<br>3.尚未发放毕业证的应届毕业生，需上传所在院校出具的毕业相关证明。
                            </div>
                        </div>
                        <div class="model-title-btn">
                            <el-button type="primary" size="mini" plain
                                @click="addChildItemFun('qualification_scholar')">添加明细</el-button>
                            <el-button
                                :icon="toggle_model.education_scholar_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('education_scholar_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="model-box-cont" v-if="toggle_model.education_scholar_toggle">
                        <educationCard ref="qualification_scholar_list"
                            v-for="(item, index) in form.qualification_scholar_list" :key="index" :form="item"
                            :index="index + 1" filed="qualification_scholar_list"
                            :show_overseas="job_detail.enableOverseasRestriction == 1"
                            @removeCall="delChildItemFun">
                        </educationCard>
                    </div>
                </div>

                <!-- ⑧ 学习/工作经历 -->
                <div class="model-box " ref="vitae_area" v-if="form.vitae_list.length > 0 && isFieldVisible('vitae_list')">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>学习/工作经历</div>
                            <div class="notice-box">
                              1.请按时间顺序填写学习/工作经历；2.学习阶段必须从高中填起；3.多段学习/工作经历可点击 "<span>添加明细</span>"继续补充。
                            </div>
                        </div>
                        <div class="model-title-btn">
                            <el-button type="primary" size="mini" plain
                                @click="addChildItemFun('vitae_list')">添加明细</el-button>
                            <el-button :icon="toggle_model.vitae_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('vitae_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="model-box-cont" v-if="toggle_model.vitae_toggle">
                        <workCard ref="vitae_list" v-for="(item, index) in form.vitae_list" :key="index" :form="item"
                            :index="index + 1" filed="vitae_list" @removeCall="delChildItemFun">
                        </workCard>
                    </div>
                </div>

                <!-- ⑨ 主要家庭成员 -->
                <div class="model-box " ref="family_area" v-if="form.family_list.length > 0 && isFieldVisible('family_list')">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>主要家庭成员</div>
                            <div class="notice-box">
                                多个家庭成员，请点击 "<span>添加明细</span>"继续补充。
                            </div>
                        </div>
                        <div class="model-title-btn">
                            <el-button type="primary" size="mini" plain
                                @click="addChildItemFun('family_list')">添加明细</el-button>
                            <el-button :icon="toggle_model.family_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('family_toggle')"></el-button>
                        </div>
                    </div>
                    <div class="model-box-cont" v-if="toggle_model.family_toggle">
                        <familyCard ref="family_list" v-for="(item, index) in form.family_list" :key="index"
                            :form="item" :index="index + 1" filed="family_list" @removeCall="delChildItemFun">
                        </familyCard>
                    </div>
                </div>

                <!-- ⑩ 其他信息 -->
                <div class="model-box">
                    <div class="model-title">
                        <div class="model-title-box">
                          <div>其他信息</div>
                          <div class="notice-box">
                            其他信息请填写：1.发表论文专著情况；2.参与主持课题情况；3.参加社会实践活动情况及获奖经历。
                          </div>
                        </div>
                        <div class="model-title-btn">
                            <el-button :icon="toggle_model.other_toggle ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                                size="mini" circle @click="toggleModelFun('other_toggle')"></el-button>
                        </div>
                    </div>
                    <el-form ref="other_form" :model="form" :rules="rules" label-width="80px" label-position="top">
                        <div class="model-box-cont" v-if="toggle_model.other_toggle">
                            <div class="model-box-cont-item model-box-cont-item-4" v-if="isFieldVisible('thesis_report')">
                                <el-form-item label="论文/课题/社会实践经历:" prop="thesis_report">
                                    <el-input v-model="form.thesis_report" type="textarea" size="small" rows="4"></el-input>
                                </el-form-item>
                            </div>
                            <div class="model-box-cont-item model-box-cont-item-2" v-if="isFieldVisible('hobby')">
                                <el-form-item label="爱好特长:" prop="hobby">
                                    <el-input v-model="form.hobby" type="textarea" size="small" rows="4"></el-input>
                                </el-form-item>
                            </div>
                            <div class="model-box-cont-item model-box-cont-item-2" v-if="isFieldVisible('self_evaluation')">
                                <el-form-item label="自我评价:" prop="self_evaluation">
                                    <el-input v-model="form.self_evaluation" type="textarea" size="small" rows="4"></el-input>
                                </el-form-item>
                            </div>
                            <div class="model-box-cont-item model-box-cont-item-4"
                                 v-if="job_detail.allowSeniorTitleRelax == 1 && (form.professional_title_level === '副高级' || form.professional_title_level === '正高级')">
                                <el-form-item label="职称证书照片:">
                                    <div class="img-list">
                                        <div class="img-box" v-for="(item, index) in form.title_certificate_img_list" :key="index">
                                            <div class="img-box-btn" @click="removeUploadFun(index, 'title_certificate_img_list')">
                                                <i class="el-icon-delete"></i>
                                            </div>
                                            <el-image v-if="isImageUrl(item)" :src="item" fit="contain" />
                                            <div v-else class="file-card" @click="openFileFun(item)">
                                                <i class="el-icon-document"></i>
                                                <span class="file-card-text">{{ getFileTypeText(item) }}</span>
                                            </div>
                                        </div>
                                        <div class="img-box">
                                            <upload-img ref="title_certificate_img_list" filed="title_certificate_img_list" :callFun="sendUpload" accept-file :file-size="10"></upload-img>
                                        </div>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="model-box-cont-item model-box-cont-item-4" v-if="isFieldVisible('certificate_img_list')">
                                <el-form-item label="获奖证书照片:">
                                    <div class="img-list">
                                        <div class="img-box" v-for="(item, index) in form.certificate_img_list" :key="index">
                                            <div class="img-box-btn" @click="removeUploadFun(index, 'certificate_img_list')">
                                                <i class="el-icon-delete"></i>
                                            </div>
                                            <el-image v-if="isImageUrl(item)" :src="item" fit="contain" />
                                            <div v-else class="file-card" @click="openFileFun(item)">
                                                <i class="el-icon-document"></i>
                                                <span class="file-card-text">{{ getFileTypeText(item) }}</span>
                                            </div>
                                        </div>
                                        <div class="img-box">
                                            <upload-img ref="certificate_img_list" filed="certificate_img_list" :callFun="sendUpload" accept-file :file-size="10"></upload-img>
                                        </div>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="model-box-cont-item model-box-cont-item-4" v-if="isFieldVisible('other_img_list')">
                                <el-form-item label="其他材料照片:">
                                    <div class="img-list">
                                        <div class="img-box" v-for="(item, index) in form.other_img_list" :key="index">
                                            <div class="img-box-btn" @click="removeUploadFun(index, 'other_img_list')">
                                                <i class="el-icon-delete"></i>
                                            </div>
                                            <el-image v-if="isImageUrl(item)" :src="item" fit="contain" />
                                            <div v-else class="file-card" @click="openFileFun(item)">
                                                <i class="el-icon-document"></i>
                                                <span class="file-card-text">{{ getFileTypeText(item) }}</span>
                                            </div>
                                        </div>
                                        <div class="img-box">
                                            <upload-img ref="other_img_list" filed="other_img_list" :callFun="sendUpload" accept-file :file-size="10"></upload-img>
                                        </div>
                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                    </el-form>
                </div>

                <!-- ⑪ 补充信息（自定义字段） -->
                <div class="model-box" v-if="customFields && customFields.length > 0">
                    <div class="model-title">
                        <div class="model-title-box">
                            <div>补充信息</div>
                        </div>
                    </div>
                    <div class="model-box-cont" style="padding: 10px 15px;">
                        <div v-for="(field, index) in customFields" :key="index" style="margin-bottom: 16px;">
                            <div style="margin-bottom: 6px; font-weight: 500;">
                                <span v-if="field.isRequired === 1" style="color:#F56C6C;margin-right:4px;">*</span>
                                {{ field.fieldLabel }}
                            </div>
                            <template v-if="field.fieldType === 1">
                                <el-input v-model="customFieldValues[index].fieldValue" type="textarea" :rows="3" size="small" :placeholder="'请填写 ' + field.fieldLabel"></el-input>
                            </template>
                            <template v-if="field.fieldType === 2">
                                <div class="img-list">
                                    <div class="img-box"
                                         v-for="(url, uIdx) in (customFieldValues[index].fieldValue ? customFieldValues[index].fieldValue.split(',').filter(u => u) : [])"
                                         :key="uIdx">
                                        <div class="img-box-btn" @click="removeCustomFieldImg(index, uIdx)">
                                            <i class="el-icon-delete"></i>
                                        </div>
                                        <el-image :src="url" fit="contain" />
                                    </div>
                                    <div class="img-box">
                                        <upload-img
                                            :ref="'custom_field_img_' + index"
                                            :filed="'custom_field_img_' + index"
                                            :callFun="(file, filed) => uploadCustomFieldImg(file, filed, index)">
                                        </upload-img>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="agree-box">
                    <el-checkbox v-model="aggrement_notice" :border="true">
                        <div class="agree-box-txt">
                            真实性声明：本人对以上填报信息的真实性、准确性、和完整性负责，凡因所填写信息及提交材料不真实、不准确、不完整而影响报名、资格审核、考试、录用的，由本人承担全部责任。
                        </div>
                    </el-checkbox>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitFun" size="small">确 定</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getNationList, uploadImageFile, levelRegistration, delAttestation} from "@/api/index.js";
import { checkIDCardNum, isImageUrl, getFileTypeText } from '@/utils';
import provinceCityCountryData from './province_city_county_data.json'
import uploadImg from './uploag_img.vue';
import educationCard from './education_card.vue'
import familyCard from './family_card.vue'
import workCard from './work_card.vue'
export default {
    name: "applyJobDialog",
    components: {
        uploadImg,
        educationCard,
        familyCard,
        workCard,
    },
    data() {
        return {
            provinceCityCountryData,
            dialogVisible: false,
            //真实声明是否确认
            truthfulStatement: false,
            //top顶部banner 通知，富文本框信息
            topBannerInfo: {},
            //民族选项列表
            nationOptions: [],
            //性别选项列表
            sexOptions: [
                { label: '男', value: '0' },
                { label: '女', value: '1' },
            ],
            //政治面貌选项列表
            politiceOptions: [
                { label: '党员', value: '1' },
                { label: '共青团员', value: '2' },
                { label: '群众', value: '3' },
                { label: '民主党派成员', value: '4' },
                { label: '无党派人士', value: '5' },
            ],
            //职称等级选项列表
            professionalTitleOptions: [
                { label: '无',   value: '无' },
                { label: '初级', value: '初级' },
                { label: '中级', value: '中级' },
                { label: '副高级', value: '副高级' },
                { label: '正高级', value: '正高级' },
            ],
            //学位选项列表
            degreeOptions: [
                { label: '无',   value: '无' },
                { label: '学士', value: '学士' },
                { label: '硕士', value: '硕士' },
                { label: '博士', value: '博士' },
            ],
            //学历选项列表
            educationaleOptions: [
                { label: '高中', value: '高中' },
                { label: '大专', value: '大专' },
                { label: '本科', value: '本科' },
                { label: '研究生', value: '研究生' },
                { label: '博士', value: '博士' },

            ],
            //应聘岗位代码选项列表
            jobCodeOptions: [],
            //家庭成员选项列表
            familyRelationShipOptions: [
                { label: '父亲', value: '父亲' },
                { label: '母亲', value: '母亲' },
                { label: '哥哥', value: '哥哥' },
                { label: '姐姐', value: '姐姐' },
                { label: '弟弟', value: '弟弟' },
                { label: '妹妹', value: '妹妹' },
            ],
            //==================================================
            //单个学位信息
            education_item: {
                school_name: '',//毕业学校
                specialty: '',//专业
                main_course: '', //主修课程
                graduation_time: '',//获得学位时间
                graduation_img: '',//毕业证照片
                degree_img: '',//学位证照片
                chsi_img: '', //学信网信息截图
                is_overseas: 0,      // 是否境外院校 0-境内 1-境外
                is_gov_sponsored: 0, // 是否公派留学生 0-否 1-是
            },
            //单个学习、工作经历信息
            vitae_item: {
                start_date: '', //开始时间
                end_date: '',//结束时间
                organization_name: '',//单位名称
                job_name: '',//职务
            },
            //单个家庭成员信息
            family_item: {
                appellation: '',//称谓
                name: '',//姓名
                birthday: '',//出生年月
                work_place: '',//工作单位或学校
                job_name: '', //职务
            },
            //提交表单西信息
            form: {
                talentIntroductionInfoId: '',
                name: '',
                phone: '',//手机
                emergency_contact_phone: '',//紧急联系人电话
                near_photo: '',//近期照片
                IdNum: '',//身份证号码
                ID_img_front: '', //身份证照片--正面
                ID_img_back: '', //身份证照片--反面
                sex: '',//性别
                nation: '', //民族
                birthday: '', //出生日期
                native_place: '',//籍贯
                college_place: '',//生源地
                politice_status: '',//政治面貌
                educational_level: '',//学历
                academic_degree: '无',//学位
                is_technician_class_graduate: 0,//是否技工院校技师（预备技师）班毕业生 0-否 1-是
                region: '', //省市区
                address: '',//详细联系地址
                qualification_high_list: [], //高中学历
                qualification_college_list: [], //专科学历
                qualification_bs_list: [], //本科学历
                qualification_grad_list: [], //研究省学历
                qualification_scholar_list: [], //博士学历
                promise: '', //声明
                vitae_list: [{
                    start_date: '', //开始时间
                    end_date: '',//结束时间
                    organization_name: '',//单位名称
                    job_name: '',//职务
                },], //学习、工作经历
                family_list: [{
                    appellation: '',//称谓
                    name: '',//姓名
                    birthday: '',//出生年月
                    work_place: '',//工作单位或学校
                    job_name: '', //职务
                },], //家庭成员
                hobby: '',//爱好
                thesis_report: '',//论文、课题、社会实践经历
                professional_title_level: '',//职称等级
                title_certificate_img_list: [], //职称证书照片
                certificate_img_list: [], //获奖证书照片
                other_img_list: [], //其他材料照片
                self_evaluation: '',//自我评价
                apply_date: '', //登记日期
            },

            //控制显隐
            toggle_model: {
                base_info_toggle: true,//基本信息区
                education_high_toggle: true, //高中区
                education_college_toggle: true, //大专区
                education_bs_toggle: true, //本科区
                education_grad_toggle: true,  //研究生区
                education_scholar_toggle: true,  //博士区
                job_detail_toggle: true, //应聘岗位详情区
                vitae_toggle: true, //学习工作经历区
                family_toggle: true,//家庭成员区
                hobby_toggle: true,//爱好特长区
                other_toggle: true, //其他区
            },
            //应聘岗位详情
            job_detail: {},
            //自定义报名字段定义列表（从岗位详情获取）
            customFields: [],
            //自定义字段填写值（与 customFields 下标对应）
            customFieldValues: [],
            //岗位表单字段配置（fieldKey → {visible, required}），空对象=全部默认
            fieldConfigMap: {},
            //各可配置字段的默认必填状态（无配置时使用）
            defaultFieldRequired: {
                emergency_contact_phone: true,
                sex: true,
                birthday: false,
                nation: true,
                politice_status: true,
                college_place: true,
                contact_address: true,
                native_place: true,
                professional_title_level: false,
                id_card_img: true,
                near_photo: true,
                vitae_list: false,
                family_list: false,
                thesis_report: false,
                hobby: false,
                self_evaluation: false,
                certificate_img_list: false,
                other_img_list: false,
            },
            aggrement_notice: false,//是否同意真实性声明
        }
    },
    computed: {
        rules() {
            //校验身份证号码规则
            var checkIDnum = (rule, value, callback) => {
                if (!!!value) {
                    callback(new Error('请填写身份证号码'));
                } else if (!checkIDCardNum(value)) {
                    callback(new Error('请填写正确的身份证号码'));
                } else {
                    callback();
                }
            };
            //固定字段：不参与岗位配置，始终显示且必填
            let rules = {
                name: [
                    { required: true, message: '请输入姓名' },
                ],
                phone: [
                    { required: true, message: '请输入手机号' },
                ],
                IdNum: [
                    { required: true, message: '请填写身份证号码' },
                    { validator: checkIDnum },
                ],
                educational_level: [
                    { required: true, message: '请选择学历' },
                ],
                academic_degree: [
                    { required: true, message: '请选择学位' },
                ],
            };
            //可配置字段：隐藏的字段不进 rules，required 按岗位配置计算
            if (this.isFieldVisible('emergency_contact_phone')) {
                rules.emergency_contact_phone = [
                    { required: this.isFieldRequired('emergency_contact_phone'), message: '请输入紧急联系人电话' },
                ];
            }
            if (this.isFieldVisible('sex')) {
                rules.sex = [
                    { required: this.isFieldRequired('sex'), message: '请选择性别' },
                ];
            }
            if (this.isFieldVisible('birthday')) {
                rules.birthday = [
                    { required: this.isFieldRequired('birthday'), message: '请选择出生日期' },
                ];
            }
            if (this.isFieldVisible('nation')) {
                rules.nation = [
                    { required: this.isFieldRequired('nation'), message: '请选择民族' },
                ];
            }
            if (this.isFieldVisible('politice_status')) {
                rules.politice_status = [
                    { required: this.isFieldRequired('politice_status'), message: '请选择政治面貌' },
                ];
            }
            if (this.isFieldVisible('college_place')) {
                rules.college_place = [
                    { required: this.isFieldRequired('college_place'), message: '请选择生源地' },
                ];
            }
            if (this.isFieldVisible('native_place')) {
                rules.native_place = [
                    { required: this.isFieldRequired('native_place'), message: '请选择籍贯' },
                ];
            }
            if (this.isFieldVisible('professional_title_level')) {
                rules.professional_title_level = [
                    { required: this.isFieldRequired('professional_title_level'), message: '请选择职称等级' },
                ];
            }
            if (this.isFieldVisible('contact_address')) {
                rules.region = [
                    { required: this.isFieldRequired('contact_address'), message: '请选择现居省市区' },
                ];
                rules.address = [
                    { required: this.isFieldRequired('contact_address'), message: '请填写详细地址' },
                ];
            }
            if (this.isFieldVisible('id_card_img')) {
                rules.ID_img_front = [
                    { required: this.isFieldRequired('id_card_img'), message: '请上传身份证正面照', trigger: 'change' },
                ];
                rules.ID_img_back = [
                    { required: this.isFieldRequired('id_card_img'), message: '请上传身份证反面照', trigger: 'change' },
                ];
            }
            if (this.isFieldVisible('near_photo')) {
                rules.near_photo = [
                    { required: this.isFieldRequired('near_photo'), message: '请上传近期免冠彩色照片', trigger: 'change' },
                ];
            }
            if (this.isFieldVisible('thesis_report')) {
                rules.thesis_report = [
                    { required: this.isFieldRequired('thesis_report'), message: '请填写论文、课题、社会实践经历' },
                ];
            }
            if (this.isFieldVisible('hobby')) {
                rules.hobby = [
                    { required: this.isFieldRequired('hobby'), message: '请填写爱好' },
                ];
            }
            if (this.isFieldVisible('self_evaluation')) {
                rules.self_evaluation = [
                    { required: this.isFieldRequired('self_evaluation'), message: '请填写自我评价' },
                ];
            }
            return rules;
        }
    },
    watch: {
        'form.educational_level': {
            handler(newVal, oldVal) {
                this.educationalChangeUnion(newVal)
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        // this.getNationOptions();

    },
    methods: {
        //解析岗位表单字段配置 JSON 字符串，失败/为空返回空对象（全默认）
        parseFormFieldConfig(configStr) {
            let map = {}
            if (!!!configStr) return map
            try {
                let list = JSON.parse(configStr)
                if (Array.isArray(list)) {
                    list.forEach(item => {
                        if (item && item.fieldKey) {
                            map[item.fieldKey] = item
                        }
                    })
                }
            } catch (e) {
                map = {}
            }
            return map
        },
        //字段是否显示：无配置默认显示
        isFieldVisible(key) {
            let cfg = this.fieldConfigMap[key]
            if (!!!cfg) return true
            return Number(cfg.visible) !== 0
        },
        //字段是否必填：无配置用默认值；隐藏字段强制非必填
        isFieldRequired(key) {
            if (!!!this.isFieldVisible(key)) return false
            let cfg = this.fieldConfigMap[key]
            if (cfg && cfg.required !== undefined && cfg.required !== null) {
                return Number(cfg.required) === 1
            }
            return !!this.defaultFieldRequired[key]
        },
        openInit(data = {}, previousFormData = null) {
            this.job_detail = { ...data }
            this.fieldConfigMap = this.parseFormFieldConfig(data.formFieldConfig)
            this.getNationOptions();
            // 初始化自定义报名字段
            const fields = (data.customFields || []).filter(f => f.fieldLabel)
            this.customFields = fields
            this.customFieldValues = fields.map(f => ({
                customFieldId: f.id,
                fieldLabel: f.fieldLabel,
                fieldType: f.fieldType,
                fieldValue: ''
            }))
            this.dialogVisible = true;

            // 如果有之前的报名信息，填充到表单中
            if (previousFormData) {
                this.$nextTick(() => {
                    // 填充基本信息
                    // API响应返回camelCase字段（Java Bean），与提交时的snake_case字段名不同
                    this.form.name = previousFormData.userName || '';
                    this.form.phone = previousFormData.phone || '';
                    this.form.emergency_contact_phone = previousFormData.emergencyContactPhone || '';
                    this.form.IdNum = previousFormData.idCard || '';
                    this.form.sex = previousFormData.sex || '';
                    this.form.nation = previousFormData.nation || '';
                    this.form.birthday = previousFormData.dateOfBirth
                        ? (typeof previousFormData.dateOfBirth === 'string'
                            ? previousFormData.dateOfBirth.substring(0, 10)
                            : new Date(previousFormData.dateOfBirth).toISOString().substring(0, 10))
                        : '';
                    this.form.politice_status = previousFormData.politicalLandscape || '';
                    this.form.educational_level = previousFormData.education || '';
                    this.form.address = previousFormData.contactAddress || '';

                    // 处理级联选择器的值（籍贯、省市区、生源地）
                    if (previousFormData.hometown) {
                        this.form.native_place = previousFormData.hometown.split('-');
                    }
                    if (previousFormData.region) {
                        this.form.region = previousFormData.region.split('-');
                    }
                    if (previousFormData.birthplace) {
                        this.form.college_place = previousFormData.birthplace.split('-');
                    }

                    // 处理照片：照片存储在 talentIntroductionEnrollPhotosList，按 picType 分类
                    // picType: "4"=身份证正面, "5"=身份证反面, "6"=一寸照片, "8"=职称证书, "1"=获奖证书, "7"=其他材料
                    const photosList = previousFormData.talentIntroductionEnrollPhotosList || [];
                    const photoMap = {};
                    const certPhotos = [];
                    const otherPhotos = [];
                    const titlePhotos = [];
                    photosList.forEach(p => {
                        if (p.picType === '4') photoMap.ID_img_front = p.picUrl;
                        else if (p.picType === '5') photoMap.ID_img_back = p.picUrl;
                        else if (p.picType === '6') photoMap.near_photo = p.picUrl;
                        else if (p.picType === '8') titlePhotos.push(p.picUrl);
                        else if (p.picType === '1') certPhotos.push(p.picUrl);
                        else if (p.picType === '7') otherPhotos.push(p.picUrl);
                    });

                    // 身份证正面照
                    if (photoMap.ID_img_front) {
                        this.form.ID_img_front = photoMap.ID_img_front;
                        this.$nextTick(() => {
                            if (this.$refs.ID_img_front) {
                                this.$refs.ID_img_front.uploadSuccess([{
                                    name: '身份证正面照',
                                    url: photoMap.ID_img_front
                                }]);
                            }
                        });
                    }

                    // 身份证反面照
                    if (photoMap.ID_img_back) {
                        this.form.ID_img_back = photoMap.ID_img_back;
                        this.$nextTick(() => {
                            if (this.$refs.ID_img_back) {
                                this.$refs.ID_img_back.uploadSuccess([{
                                    name: '身份证反面照',
                                    url: photoMap.ID_img_back
                                }]);
                            }
                        });
                    }

                    // 近期一寸免冠照片
                    if (photoMap.near_photo) {
                        this.form.near_photo = photoMap.near_photo;
                        this.$nextTick(() => {
                            if (this.$refs.near_photo) {
                                this.$refs.near_photo.uploadSuccess([{
                                    name: '近期一寸免冠照片',
                                    url: photoMap.near_photo
                                }]);
                            }
                        });
                    }

                    // 职称证书照片
                    if (titlePhotos.length > 0) {
                        this.form.title_certificate_img_list = titlePhotos;
                    }
                    // 获奖证书照片
                    if (certPhotos.length > 0) {
                        this.form.certificate_img_list = certPhotos;
                    }
                    // 其他材料照片
                    if (otherPhotos.length > 0) {
                        this.form.other_img_list = otherPhotos;
                    }

                    // 将 API 响应的毕业学校对象（camelCase）转换为表单格式（snake_case）
                    const convertSchool = (item) => ({
                        school_name: item.graduationSchool || '',
                        specialty: item.major || '',
                        main_course: item.mainCourse || '',
                        graduation_time: item.degreeTime
                            ? (typeof item.degreeTime === 'string'
                                ? item.degreeTime.substring(0, 10)
                                : new Date(item.degreeTime).toISOString().substring(0, 10))
                            : '',
                        graduation_img: item.graduationImg || '',
                        degree_img: item.degreeImg || '',
                        chsi_img: item.chsiImg || '',
                        is_overseas: item.isOverseas || 0,
                        is_gov_sponsored: item.isGovSponsored || 0,
                    });

                    // 填充学历信息
                    const highList = previousFormData.talentIntroductionEnrollGraduationSchoolListFour || [];
                    if (highList.length > 0) {
                        this.form.qualification_high_list = highList.map(convertSchool);
                        // 处理高中学历证书照片
                        this.$nextTick(() => {
                            this.form.qualification_high_list.forEach((item, index) => {
                                if (item.graduation_img && this.$refs.qualification_high_list && this.$refs.qualification_high_list[index]) {
                                    this.$refs.qualification_high_list[index].updateImageDisplay('graduation_img', item.graduation_img);
                                }
                            });
                        });
                    }

                    const collegeList = previousFormData.talentIntroductionEnrollGraduationSchoolListFive || [];
                    if (collegeList.length > 0) {
                        this.form.qualification_college_list = collegeList.map(convertSchool);
                        // 处理大专学历证书照片
                        this.$nextTick(() => {
                            this.form.qualification_college_list.forEach((item, index) => {
                                if (this.$refs.qualification_college_list && this.$refs.qualification_college_list[index]) {
                                    if (item.graduation_img) {
                                        this.$refs.qualification_college_list[index].updateImageDisplay('graduation_img', item.graduation_img);
                                    }
                                    if (item.chsi_img) {
                                        this.$refs.qualification_college_list[index].updateImageDisplay('chsi_img', item.chsi_img);
                                    }
                                }
                            });
                        });
                    }

                    const bsList = previousFormData.talentIntroductionEnrollGraduationSchoolList || [];
                    if (bsList.length > 0) {
                        this.form.qualification_bs_list = bsList.map(convertSchool);
                        // 处理本科学历证书照片
                        this.$nextTick(() => {
                            this.form.qualification_bs_list.forEach((item, index) => {
                                if (this.$refs.qualification_bs_list && this.$refs.qualification_bs_list[index]) {
                                    if (item.graduation_img) {
                                        this.$refs.qualification_bs_list[index].updateImageDisplay('graduation_img', item.graduation_img);
                                    }
                                    if (item.degree_img) {
                                        this.$refs.qualification_bs_list[index].updateImageDisplay('degree_img', item.degree_img);
                                    }
                                    if (item.chsi_img) {
                                        this.$refs.qualification_bs_list[index].updateImageDisplay('chsi_img', item.chsi_img);
                                    }
                                }
                            });
                        });
                    }

                    const gradList = previousFormData.talentIntroductionEnrollGraduationSchoolListTwo || [];
                    if (gradList.length > 0) {
                        this.form.qualification_grad_list = gradList.map(convertSchool);
                        // 处理研究生学历证书照片
                        this.$nextTick(() => {
                            this.form.qualification_grad_list.forEach((item, index) => {
                                if (this.$refs.qualification_grad_list && this.$refs.qualification_grad_list[index]) {
                                    if (item.graduation_img) {
                                        this.$refs.qualification_grad_list[index].updateImageDisplay('graduation_img', item.graduation_img);
                                    }
                                    if (item.degree_img) {
                                        this.$refs.qualification_grad_list[index].updateImageDisplay('degree_img', item.degree_img);
                                    }
                                    if (item.chsi_img) {
                                        this.$refs.qualification_grad_list[index].updateImageDisplay('chsi_img', item.chsi_img);
                                    }
                                }
                            });
                        });
                    }

                    const scholarList = previousFormData.talentIntroductionEnrollGraduationSchoolListThree || [];
                    if (scholarList.length > 0) {
                        this.form.qualification_scholar_list = scholarList.map(convertSchool);
                        // 处理博士学历证书照片
                        this.$nextTick(() => {
                            this.form.qualification_scholar_list.forEach((item, index) => {
                                if (this.$refs.qualification_scholar_list && this.$refs.qualification_scholar_list[index]) {
                                    if (item.graduation_img) {
                                        this.$refs.qualification_scholar_list[index].updateImageDisplay('graduation_img', item.graduation_img);
                                    }
                                    if (item.degree_img) {
                                        this.$refs.qualification_scholar_list[index].updateImageDisplay('degree_img', item.degree_img);
                                    }
                                    if (item.chsi_img) {
                                        this.$refs.qualification_scholar_list[index].updateImageDisplay('chsi_img', item.chsi_img);
                                    }
                                }
                            });
                        });
                    }

                    // 填充工作经历（API: talentIntroductionEnrollLearningAndWorkList，字段 camelCase → snake_case）
                    const vitaeList = previousFormData.talentIntroductionEnrollLearningAndWorkList || [];
                    if (vitaeList.length > 0) {
                        this.form.vitae_list = vitaeList.map(item => ({
                            start_date: item.startDate
                                ? (typeof item.startDate === 'string' ? item.startDate.substring(0, 10) : new Date(item.startDate).toISOString().substring(0, 10))
                                : '',
                            end_date: item.endDate
                                ? (typeof item.endDate === 'string' ? item.endDate.substring(0, 10) : new Date(item.endDate).toISOString().substring(0, 10))
                                : '',
                            organization_name: item.schoolOrWorkplace || '',
                            job_name: item.duties || '',
                        }));
                    }

                    // 填充家庭成员（API: talentIntroductionEnrollFamilyMembersList，字段 camelCase → snake_case）
                    const familyList = previousFormData.talentIntroductionEnrollFamilyMembersList || [];
                    if (familyList.length > 0) {
                        this.form.family_list = familyList.map(item => ({
                            appellation: item.appellation || '',
                            name: item.moniker || '',
                            birthday: item.dateOfBirth
                                ? (typeof item.dateOfBirth === 'string' ? item.dateOfBirth.substring(0, 10) : new Date(item.dateOfBirth).toISOString().substring(0, 10))
                                : '',
                            work_place: item.occupation || '',
                            job_name: item.duties || '',
                        }));
                    }

                    // 填充其他信息
                    this.form.hobby = previousFormData.hobbiesAndSpecialties || '';
                    this.form.thesis_report = previousFormData.enrollOverview || '';
                    this.form.self_evaluation = previousFormData.selfEvaluation || '';
                    this.form.professional_title_level = previousFormData.professionalTitleLevel || '';
                    // 学位、技工院校技师班毕业生：历史数据为 NULL 时按默认值回填
                    this.form.academic_degree = previousFormData.academicDegree || '无';
                    this.form.is_technician_class_graduate = previousFormData.isTechnicianClassGraduate == null ? 0 : previousFormData.isTechnicianClassGraduate;

                    // 显示提示信息
                    this.$message({
                        message: '已自动填充您上次的报名信息，请修改后重新提交',
                        type: 'info',
                        duration: 5000
                    });
                });
            }
        },
        //获取民族列表选项
        getNationOptions() {
            getNationList({}).then(res => {
                if (res.code == 200) {
                    let get_list = res.data.map(item => {
                        item.value = item.nationId;
                        item.label = item.nationName;
                        return item;
                    })
                    localStorage.setItem('nationOptions', get_list)
                    this.nationOptions = get_list;
                }
            })
        },

        //各模块控制显隐
        toggleModelFun(value) {
            let get_name = value || ''
            let toggle_model = this.toggle_model || false
            toggle_model[get_name] = !!!toggle_model[get_name]
        },

        //学历联动
        educationalChangeUnion(level) {
            if (!!!level) return false;
            let get_form_data = this.form;
            var data_item = JSON.parse(JSON.stringify(this.education_item))
            let except_list = ['高中', '大专'];
            if (except_list.indexOf(level) != -1) {
                get_form_data.qualification_bs_list = [];
                get_form_data.qualification_grad_list = [];
                get_form_data.qualification_scholar_list = [];
            } else {
                get_form_data.qualification_high_list = [];
                get_form_data.qualification_college_list = [];
            }
            switch (level) {
                case '高中':
                    var high_list = get_form_data.qualification_high_list || [];
                    if (high_list.length == 0) {
                        high_list.push(data_item);
                    }
                    get_form_data.qualification_college_list = [];
                    break;
                case '大专':
                    var college_list = get_form_data.qualification_college_list;
                    if (college_list.length == 0) {
                        college_list.push(data_item);
                    }
                    get_form_data.qualification_high_list = [];
                    break;
                case '本科':
                    var bs_list = get_form_data.qualification_bs_list;
                    if (bs_list.length == 0) {
                        bs_list.push(data_item);
                    }
                    get_form_data.qualification_grad_list = [];
                    get_form_data.qualification_scholar_list = [];
                    break;
                case '研究生':
                    var bs_list = get_form_data.qualification_bs_list;
                    if (bs_list.length == 0) {
                        let copy_data = JSON.parse(JSON.stringify(data_item))
                        bs_list.push(copy_data);
                    }
                    var grad_list = get_form_data.qualification_grad_list;
                    if (grad_list.length == 0) {
                        grad_list.push(data_item);
                    }
                    get_form_data.qualification_scholar_list = [];
                    break;
                case '博士':
                    var bs_list = get_form_data.qualification_bs_list;
                    if (bs_list.length == 0) {
                        let copy_data = JSON.parse(JSON.stringify(data_item))
                        bs_list.push(copy_data);
                    }
                    var grad_list = get_form_data.qualification_grad_list;
                    if (grad_list.length == 0) {
                        let copy_data = JSON.parse(JSON.stringify(data_item))
                        grad_list.push(copy_data);
                    }
                    var scholar_list = get_form_data.qualification_scholar_list;
                    if (scholar_list.length == 0) {
                        scholar_list.push(data_item);
                    }
                    break;
            }
        },
        //添加明细方法
        addChildItemFun(value) {
            let get_form_data = this.form;
            switch (value) {
                case 'qualification_high':
                    var data_item = JSON.parse(JSON.stringify(this.education_item))
                    get_form_data.qualification_high_list.push(data_item)
                    break;
                case 'qualification_college':
                    var data_item = JSON.parse(JSON.stringify(this.education_item))
                    get_form_data.qualification_college_list.push(data_item)
                    break;
                case 'qualification_bs':
                    var data_item = JSON.parse(JSON.stringify(this.education_item))
                    get_form_data.qualification_bs_list.push(data_item)
                    break;
                case 'qualification_grad':
                    var data_item = JSON.parse(JSON.stringify(this.education_item))
                    get_form_data.qualification_grad_list.push(data_item)
                    break;
                case 'qualification_scholar':
                    var data_item = JSON.parse(JSON.stringify(this.education_item))
                    get_form_data.qualification_scholar_list.push(data_item)
                    break;
                case 'vitae_list':
                    var data_item = JSON.parse(JSON.stringify(this.vitae_item))
                    get_form_data.vitae_list.push(data_item)
                    break;
                case 'family_list':
                    var data_item = JSON.parse(JSON.stringify(this.family_item))
                    get_form_data.family_list.push(data_item)
                    break;
            }
        },

        //移除明细方法
        delChildItemFun(parms) {
            let { index, filed_str } = parms
            if (!!!index || !!!filed_str) return false;
            let get_form_data = this.form;
            get_form_data[filed_str].splice(--index, 1)
        },

        //移出照片
        removeUploadFun(index, filed_str) {
            let getForm = this.form;
            getForm[filed_str].splice(index, 1)
        },
        //判断url是否为图片（回显用）
        isImageUrl(url) {
            return isImageUrl(url);
        },
        //获取文件类型展示文案（回显用）
        getFileTypeText(url) {
            return getFileTypeText(url);
        },
        //新窗口打开文件
        openFileFun(url) {
            if (url) window.open(url, '_blank');
        },
        //自定义上传的方法
        sendUpload(file, filed_str) {
            let formData = new FormData();
            formData.append('file', file);
            let filed_img_list = ['certificate_img_list', 'other_img_list', 'title_certificate_img_list'];
            uploadImageFile(formData).then(res => {
                let { code, url, newFileName, msg } = res;
                if (code == 200 && !!url) {
                    if (filed_img_list.indexOf(filed_str) != -1) {
                        this.$refs[filed_str].uploadSuccess([])
                        this.form[filed_str].push(url)
                    } else {
                        let show_pic = {
                            name: newFileName,
                            url: url
                        }
                        this.$refs[filed_str].uploadSuccess([show_pic])
                        this.form[filed_str] = url || ''
                    }
                } else {
                    this.$refs[filed_str].uploadSuccess([])
                    this.$message.warning('图片上传失败，请重试;', msg)
                }
            }).catch(err => {
                this.$refs[filed_str].uploadSuccess([])
                this.$message.warning('图片上传失败，请重试;', err)
            })
        },
        //
        baseFormCheck() {
            let check_1 = new Promise((resolve, reject) => {
                this.$refs.base_form.validate((valid) => {
                    if (valid) {
                        resolve(true)
                    } else {
                        reject('base_form')
                    }
                });
            })
            let check_2 = new Promise((resolve, reject) => {
                this.$refs.other_form.validate((valid) => {
                    if (valid) {
                        resolve(true)
                    } else {
                        reject('other_form')
                    }
                });
            })
            return new Promise((resolve, reject) => {
                let result_obj = {
                    mark: 'base_info_result'
                }
                Promise.all([check_1, check_2]).then(res => {
                    let copy_form = JSON.parse(JSON.stringify(this.form))
                    //级联字段可能被岗位配置隐藏而保持字符串初值，需判空兼容
                    copy_form.native_place = Array.isArray(copy_form.native_place) ? copy_form.native_place.join('-') : (copy_form.native_place || '')
                    copy_form.college_place = Array.isArray(copy_form.college_place) ? copy_form.college_place.join('-') : (copy_form.college_place || '')
                    copy_form.region = Array.isArray(copy_form.region) ? copy_form.region.join('-') : (copy_form.region || '')
                    result_obj.data = copy_form;
                    resolve(result_obj)
                }).catch(err => {
                    result_obj.msg = err
                    reject(result_obj)

                })
            })
        },
        cardFormCheck(check_list = []) {
            let result_obj = {}
            if (Array.isArray(check_list) && check_list.length > 0) {
                let promise_list = []
                for (let i = 0; i < check_list.length; i++) {
                    let check_item = check_list[i].submitCheck();
                    promise_list.push(check_item)
                }
                return new Promise((resolve, reject) => {
                    Promise.all(promise_list).then(res => {
                        result_obj.data = res
                        resolve(result_obj)
                    }).catch(err => {
                        result_obj.msg = err
                        reject(result_obj)
                    })
                })
            } else {
                return new Promise((resolve, reject) => {
                    result_obj.data = []
                    resolve(result_obj)
                })
            }

        },
        //提交前的检查
        async submitBefore() {
            let merge_Data = {}
            let check_base_result = false;
            await this.baseFormCheck().then(res => {
                let { data = {} } = res;
                merge_Data = { ...merge_Data, ...data }
                check_base_result = true
            }).catch(err => {
                check_base_result = false;
            })

            let qualification_high_refs = this.$refs.qualification_high_list;
            let check_qualification_high_result = false;
            await this.cardFormCheck(qualification_high_refs).then(res => {
                let { data = [] } = res;
                merge_Data.qualification_high_list = [...data]
                check_qualification_high_result = true
            }).catch(err => {
                check_qualification_high_result = false
            })

            let qualification_college_refs = this.$refs.qualification_college_list;
            let check_qualification_college_result = false;
            await this.cardFormCheck(qualification_college_refs).then(res => {
                let { data = [] } = res;
                merge_Data.qualification_college_list = [...data]
                check_qualification_college_result = true
            }).catch(err => {
                check_qualification_college_result = false
            })

            let qualification_bs_refs = this.$refs.qualification_bs_list;
            let check_qualification_bs_result = false;
            await this.cardFormCheck(qualification_bs_refs).then(res => {
                let { data = [] } = res;
                merge_Data.qualification_bs_list = [...data]
                check_qualification_bs_result = true
            }).catch(err => {
                check_qualification_bs_result = false
            })

            let qualification_grad_refs = this.$refs.qualification_grad_list;
            let check_qualification_grad_result = false;
            await this.cardFormCheck(qualification_grad_refs).then(res => {
                let { data = [] } = res;
                merge_Data.qualification_grad_list = [...data]
                check_qualification_grad_result = true
            }).catch(err => {
                check_qualification_grad_result = false
            })

            let qualification_scholar_refs = this.$refs.qualification_scholar_list;
            let check_qualification_scholar_result = false;
            await this.cardFormCheck(qualification_scholar_refs).then(res => {
                let { data = [] } = res;
                merge_Data.qualification_scholar_list = [...data]
                check_qualification_scholar_result = true
            }).catch(err => {
                check_qualification_scholar_result = false
            })

            //学习/工作经历：隐藏的区块跳过校验（旧值保留在 merge_Data 中）；配置必填时校验至少一条记录
            let check_vitae_list_result = true;
            if (this.isFieldVisible('vitae_list')) {
                if (this.isFieldRequired('vitae_list') &&
                    !!!this.form.vitae_list.some(item => item && (item.start_date || item.end_date || item.organization_name || item.job_name))) {
                    this.$message.warning('请填写学习、工作经历')
                    check_vitae_list_result = false
                } else {
                    check_vitae_list_result = false
                    let vitae_list_refs = this.$refs.vitae_list;
                    await this.cardFormCheck(vitae_list_refs).then(res => {
                        let { data = [] } = res;
                        merge_Data.vitae_list = [...data]
                        check_vitae_list_result = true
                    }).catch(err => {
                        check_vitae_list_result = false
                    })
                }
            }

            //主要家庭成员：隐藏的区块跳过校验（旧值保留在 merge_Data 中）；配置必填时校验至少一条记录
            let check_family_list_result = true;
            if (this.isFieldVisible('family_list')) {
                if (this.isFieldRequired('family_list') &&
                    !!!this.form.family_list.some(item => item && (item.appellation || item.name || item.birthday || item.work_place || item.job_name))) {
                    this.$message.warning('请填写家庭成员')
                    check_family_list_result = false
                } else {
                    check_family_list_result = false
                    let family_list_refs = this.$refs.family_list;
                    await this.cardFormCheck(family_list_refs).then(res => {
                        let { data = [] } = res;
                        merge_Data.family_list = [...data]
                        check_family_list_result = true
                    }).catch(err => {
                        check_family_list_result = false
                    })
                }
            }


            let result_list = [check_base_result, check_qualification_high_result, check_qualification_college_result, check_qualification_bs_result, check_qualification_grad_result, check_qualification_scholar_result, check_vitae_list_result, check_family_list_result]
            let result_idx = result_list.findIndex(item => !!!item)

            if (result_idx !== -1) {
                const areaRefMap = ['base_area', 'child_high_area', 'child_college_area', 'child_bs_area', 'child_grad_area', 'child_scholar_area', 'vitae_area', 'family_area']
                const toggleKeyMap = ['base_info_toggle', 'education_high_toggle', 'education_college_toggle', 'education_bs_toggle', 'education_grad_toggle', 'education_scholar_toggle', 'vitae_toggle', 'family_toggle']
                const toggleKey = toggleKeyMap[result_idx]
                if (toggleKey && !this.toggle_model[toggleKey]) {
                    this.toggle_model[toggleKey] = true
                }
                this.$nextTick(() => {
                    const el = this.$refs[areaRefMap[result_idx]]
                    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                })
            }
            let merge_result = check_base_result && check_qualification_high_result && check_qualification_college_result && check_qualification_bs_result && check_qualification_grad_result && check_qualification_scholar_result && check_vitae_list_result && check_family_list_result;
            let result_info = {
                result: merge_result,
                data: merge_Data
            }
            return result_info;
        },
        //提交数据
        async submitFun() {
            const that = this
            let chechResultInfo = await that.submitBefore()
            let { result, data } = chechResultInfo
            if (!!!result) {
                that.$message.error('您还有未填信息')
                return false;
            }
            let aggrement_notice = that.aggrement_notice
            if (!!!aggrement_notice) {
                this.$message.warning('请勾选信息真实性承诺')
                return false;
            }
            that.$confirm('确定提交吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.submitSignUp(data)
            })
        },
        //提交报名   levelRegistration
        submitSignUp(form_data) {
            let get_query = this.$route.query;
            form_data.talentIntroductionInfoId = this.job_detail.id || ''

            // 学位必填校验（兜底，正常由表单 rules 拦截）
            if (!!!form_data.academic_degree) {
                this.$message.warning('请选择学位')
                return false
            }

            // 岗位未开启技工院校技师班放宽时，不显示该选项，提交默认 0
            if (this.job_detail.allowTechnicianClassRelax != 1) {
                form_data.is_technician_class_graduate = 0
            }

            // 副高职称放宽学历：若开启且选择了副高级/正高级，则职称证书必填
            if (this.job_detail.allowSeniorTitleRelax == 1 &&
                (form_data.professional_title_level === '副高级' || form_data.professional_title_level === '正高级') &&
                (!form_data.title_certificate_img_list || form_data.title_certificate_img_list.length === 0)) {
                this.$message.warning('请上传职称证书照片')
                return false
            }

            // 校验必填自定义字段
            for (let i = 0; i < this.customFields.length; i++) {
                const field = this.customFields[i]
                const val = this.customFieldValues[i] && this.customFieldValues[i].fieldValue
                if (field.isRequired === 1 && (!val || val.trim() === '')) {
                    this.$message.warning(`请填写：${field.fieldLabel}`)
                    return false
                }
            }
            form_data.customFieldValues = this.customFieldValues.filter(v => v.fieldValue && v.fieldValue.trim() !== '')

            levelRegistration(form_data).then(res => {
                let {code, msg} = res;
                if(code == 200) {
                    this.$message.success('提交成功')
                    this.dialogVisible = false;
                }else {
                    this.$message.error(`提交失败 ${msg}`)
                }

            }).catch(err => {
                this.$message.error(`提交失败，请重试`)
            })
        },

        //弹框关闭的回调处理
        afterCloseInitFun() {
            let init_form = {
                talentIntroductionInfoId: '',
                name: '',
                phone: '',//手机
                emergency_contact_phone: '',//紧急联系人电话
                near_photo: '',//近期照片
                IdNum: '',//身份证号码
                ID_img_front: '', //身份证照片--正面
                ID_img_back: '', //身份证照片--反面
                sex: '',//性别
                nation: '', //民族
                birthday: '', //出生日期
                native_place: '',//籍贯
                college_place: '',//生源地
                politice_status: '',//政治面貌
                educational_level: '',//学历
                academic_degree: '无',//学位
                is_technician_class_graduate: 0,//是否技工院校技师（预备技师）班毕业生 0-否 1-是
                region: '', //省市区
                address: '',//详细联系地址
                qualification_high_list: [], //高中学历
                qualification_college_list: [], //专科学历
                qualification_bs_list: [], //本科学历
                qualification_grad_list: [], //研究省学历
                qualification_scholar_list: [], //博士学历
                promise: '', //声明
                vitae_list: [{
                    start_date: '', //开始时间
                    end_date: '',//结束时间
                    organization_name: '',//单位名称
                    job_name: '',//职务
                },], //学习、工作经历
                family_list: [{
                    appellation: '',//称谓
                    name: '',//姓名
                    birthday: '',//出生年月
                    work_place: '',//工作单位或学校
                    job_name: '', //职务
                },], //家庭成员
                hobby: '',//爱好
                thesis_report: '',//论文、课题、社会实践经历
                professional_title_level: '',//职称等级
                title_certificate_img_list: [], //职称证书照片
                certificate_img_list: [], //获奖证书照片
                other_img_list: [], //其他材料照片
                self_evaluation: '',//自我评价
                apply_date: '', //登记日期
            }
            let copy_form = JSON.parse(JSON.stringify(init_form))
            this.form = copy_form;
            this.job_detail = {}
            this.fieldConfigMap = {}
            this.aggrement_notice = false;
            this.$refs.base_form.resetFields();
            //字段被岗位配置隐藏时对应 ref 不存在，需判空
            if (this.$refs.ID_img_front) this.$refs.ID_img_front.initFileList()
            if (this.$refs.ID_img_back) this.$refs.ID_img_back.initFileList()
            if (this.$refs.near_photo) this.$refs.near_photo.initFileList()

            // 重置自定义字段
            this.customFields = []
            this.customFieldValues = []

            this.dialogVisible = false;

        },

        // 移除自定义字段图片
        removeCustomFieldImg(fieldIndex, imgIndex) {
            const val = this.customFieldValues[fieldIndex].fieldValue || ''
            const arr = val.split(',').filter(u => u)
            arr.splice(imgIndex, 1)
            this.customFieldValues[fieldIndex].fieldValue = arr.join(',')
        },

        // 上传自定义字段图片
        uploadCustomFieldImg(file, filed, fieldIndex) {
            let formData = new FormData()
            formData.append('file', file)
            uploadImageFile(formData).then(res => {
                let { code, url } = res
                if (code == 200 && url) {
                    const refKey = 'custom_field_img_' + fieldIndex
                    const refComp = this.$refs[refKey]
                    if (refComp && refComp[0]) refComp[0].uploadSuccess([])
                    const prev = this.customFieldValues[fieldIndex].fieldValue
                    this.customFieldValues[fieldIndex].fieldValue = prev ? (prev + ',' + url) : url
                } else {
                    this.$message.warning('图片上传失败，请重试')
                }
            }).catch(() => {
                this.$message.warning('图片上传失败，请重试')
            })
        },
    }
}

</script>
<style lang="scss" scoped>
/* ===== 全局 box-sizing ===== */
.main-cont,
.main-cont * {
    box-sizing: border-box !important;
}

/* ===== 主容器 ===== */
.main-cont {
    width: auto;
    height: auto;
    overflow: hidden;

    /* ===== 分区卡片 ===== */
    .model-box {
        width: auto;
        overflow: hidden;
        margin-bottom: 16px;
        border-radius: 10px;
        border: 1px solid #E0F2FE;
        background: #fff;
        box-shadow: 0 1px 6px rgba(3, 105, 161, 0.06);
        transition: box-shadow 0.2s;

        &:hover {
            box-shadow: 0 3px 12px rgba(3, 105, 161, 0.1);
        }

        /* ===== 区块标题栏 ===== */
        .model-title {
            font-size: 15px;
            font-weight: 600;
            color: #0C4A6E;
            padding: 12px 16px;
            background: linear-gradient(to right, #F0F9FF, #fff);
            border-bottom: 1px solid #E0F2FE;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .model-title-box {
                display: inline-flex;
                align-items: center;
                gap: 6px;

                & > div:first-child {
                    position: relative;
                    padding-left: 12px;

                    &::before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 4px;
                        height: 16px;
                        background: linear-gradient(to bottom, #0369A1, #0EA5E9);
                        border-radius: 2px;
                    }
                }
            }

            .model-title-btn {
                display: inline-flex;
                align-items: center;
                gap: 8px;
            }
        }

        /* ===== 区块内容区 ===== */
        .model-box-cont {
            width: auto;
            height: auto;
            overflow: hidden;
            padding: 14px 16px 6px;

            .model-box-cont-item-out {
                position: relative;
                top: -12px;
            }

            .model-box-cont-item {
                width: calc(100% / 4);
                padding-right: 10px;
                display: inline-block;
                vertical-align: top;

                .model-box-cont-item {
                    padding-right: 0;
                }

                /* ===== 图片列表 ===== */
                .img-list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;

                    .img-box {
                        width: 148px;
                        height: 148px;
                        margin: 0;
                        border: 1.5px dashed #BAE6FD;
                        border-radius: 8px;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        overflow: hidden;
                        position: relative;
                        background: #F8FAFC;
                        transition: border-color 0.2s;

                        &:hover { border-color: #0369A1; }

                        /* 非图片文件卡片 */
                        .file-card {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                            color: #475569;

                            &:hover { color: #0369A1; }

                            i {
                                font-size: 40px;
                                color: #0369A1;
                            }

                            .file-card-text {
                                font-size: 13px;
                                margin-top: 8px;
                            }
                        }

                        .img-box-btn {
                            width: 24px;
                            height: 24px;
                            position: absolute;
                            top: 4px;
                            right: 4px;
                            z-index: 500;
                            background: rgba(244, 63, 94, 0.85);
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 50%;
                            cursor: pointer;
                            transition: background 0.15s;

                            &:hover { background: #F43F5E; }

                            i {
                                color: #fff;
                                font-size: 12px;
                            }
                        }
                    }

                    .img-box:last-child {
                        border-style: dashed;
                    }
                }
            }

            .model-box-cont-item-2 { width: calc((100% / 4) * 2); }
            .model-box-cont-item-3 { width: calc((100% / 4) * 3); }
            .model-box-cont-item-4 { width: 100%; }

            /* ===== 岗位详情展示行 ===== */
            .model-box-cont-derail {
                display: inline-flex;
                align-items: flex-start;
                margin: 6px 0;
                padding: 8px 12px;
                background: #F8FAFC;
                border-radius: 6px;
                border: 1px solid #E2E8F0;

                .model-box-cont-item-label {
                    width: 110px;
                    min-width: 110px;
                    display: inline-block;
                    text-align: right;
                    padding-right: 10px;
                    color: #64748B;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.5;
                    flex-shrink: 0;
                }

                .model-box-cont-item-value {
                    width: calc(100% - 110px);
                    display: inline-block;
                    color: #1E293B;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.5;
                }
            }
        }
    }

    .model-box-inner {
        .model-title { padding: 5px 0; }
    }

    /* ===== 填写说明提示 ===== */
    .notice-box {
        padding: 3px 10px;
        font-size: 12px;
        color: #94A3B8;
        background: #FFF7ED;
        border-radius: 4px;
        border: 1px solid #FED7AA;
        margin-left: 8px;

        span {
            color: #EA580C;
            font-weight: 600;
        }
    }
}

/* ===== 真实性声明区域 ===== */
.agree-box {
    margin: 16px 0 8px;
    width: 100%;

    .agree-box-txt {
        display: inline-block;
        word-break: break-all;
        font-size: 13px;
        line-height: 1.6;
    }
}

/* ===== 底部按钮区 ===== */
.dialog-footer {
    display: flex;
    justify-content: center;
    gap: 16px;
    padding: 4px 0;
}

/* ===== Element UI 组件覆盖 ===== */
:deep(.el-dialog) {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
        background: linear-gradient(135deg, #0369A1 0%, #0EA5E9 100%);
        padding: 16px 20px;

        .el-dialog__title {
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 1px;
        }

        .el-dialog__headerbtn {
            top: 16px;
            right: 20px;

            .el-dialog__close {
                color: rgba(255, 255, 255, 0.85);
                font-size: 18px;
                &:hover { color: #fff; }
            }
        }
    }
}

:deep(.el-dialog__body) {
    padding: 16px 20px !important;
    background: #F8FAFC;
    max-height: 72vh;
    overflow-y: auto;

    &::-webkit-scrollbar { width: 6px; }
    &::-webkit-scrollbar-track { background: #f1f5f9; }
    &::-webkit-scrollbar-thumb {
        background: #BAE6FD;
        border-radius: 3px;
        &:hover { background: #7DD3FC; }
    }
}

:deep(.el-dialog__footer) {
    background: #fff;
    border-top: 1px solid #E0F2FE;
    padding: 14px 20px;
}

:deep(.el-form-item__label) {
    line-height: 1.2 !important;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
}


:deep(.el-form-item__error) {
    font-size: 12px;
}

:deep(.el-input__inner) {
    border-color: #CBD5E1;
    border-radius: 6px;
    color: #1E293B;
    font-size: 13px;
    background: #fff;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
        border-color: #0369A1;
        box-shadow: 0 0 0 2px rgba(3, 105, 161, 0.12);
    }
}

:deep(.el-select .el-input__inner),
:deep(.el-cascader .el-input__inner) {
    border-color: #CBD5E1;
    border-radius: 6px;
}

:deep(.el-date-editor) {
    width: 100% !important;
}

:deep(.el-textarea__inner) {
    border-color: #CBD5E1;
    border-radius: 6px;
    font-size: 13px;
    color: #1E293B;
    resize: vertical;

    &:focus {
        border-color: #0369A1;
        box-shadow: 0 0 0 2px rgba(3, 105, 161, 0.12);
    }
}

:deep(.el-button--mini) {
    padding: 5px 14px !important;
    border-radius: 6px;
    font-size: 12px;
}

:deep(.is-circle.el-button--mini) {
    padding: 5px !important;
    width: 28px;
    height: 28px;
}

:deep(.el-button--primary.is-plain) {
    background: #EFF6FF;
    border-color: #BFDBFE;
    color: #1D4ED8;

    &:hover {
        background: #DBEAFE;
        border-color: #93C5FD;
        color: #1D4ED8;
    }
}

:deep(.dialog-footer .el-button--primary) {
    background: linear-gradient(135deg, #0369A1, #0EA5E9);
    border: none;
    border-radius: 8px;
    padding: 10px 36px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    box-shadow: 0 2px 8px rgba(3, 105, 161, 0.3);
    transition: opacity 0.2s, transform 0.15s;

    &:hover { opacity: 0.9; transform: translateY(-1px); }
    &:active { transform: translateY(0); }
}

:deep(.dialog-footer .el-button:not(.el-button--primary)) {
    border-radius: 8px;
    padding: 10px 28px;
    font-size: 14px;
    color: #475569;
    border-color: #CBD5E1;

    &:hover {
        color: #0369A1;
        border-color: #0369A1;
        background: #F0F9FF;
    }
}

:deep(.el-checkbox) {
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding: 14px 16px;
    height: auto;
    overflow: hidden;
    border-radius: 8px;
    background: #FFF7ED;
    border: 1px solid #FED7AA;

    .el-checkbox__input {
        margin-top: 3px;
        flex-shrink: 0;
    }

    .el-checkbox__inner {
        border-color: #F59E0B;
        border-radius: 3px;
        &:hover { border-color: #D97706; }
    }

    &.is-checked .el-checkbox__inner {
        background: #F59E0B;
        border-color: #F59E0B;
    }

    .el-checkbox__label {
        width: calc(100% - 20px);
        color: #92400E;
        font-size: 13px;
        line-height: 1.6;
        white-space: normal;

        .agree-box-txt {
            width: 100%;
            word-break: break-all;
            white-space: normal;
        }
    }
}

/* ===== 岗位信息无边框 info grid ===== */
.job-info-box {
    border-left: 4px solid #0369A1 !important;
}

.job-info-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0;
    padding: 16px 20px 8px;
}

.job-info-item {
    display: flex;
    flex-direction: column;
    padding: 10px 14px;
    border-radius: 0;

    &--wide {
        grid-column: span 2;
    }

    .job-info-label {
        font-size: 11px;
        color: #94A3B8;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
    }

    .job-info-value {
        font-size: 14px;
        color: #1E293B;
        font-weight: 500;
        line-height: 1.4;

        &.highlight {
            color: #0369A1;
            font-size: 16px;
            font-weight: 700;
        }
    }
}

/* ===== 基本信息 - 文字录入网格 ===== */
.base-fields-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0 10px;
    padding: 0;

    .base-field-item {
        min-width: 0;

        &--span2 {
            grid-column: span 2;
        }
    }
}

/* 职称提示文字 */
.field-tip {
    color: #E6A23C;
    font-size: 12px;
    margin-top: 4px;
    line-height: 1.4;
}

/* ===== 证件照片上传区 ===== */
.photo-upload-section {
    margin-top: 16px;
    padding-top: 8px;

    .photo-section-title {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;

        .photo-section-line {
            flex: 1;
            height: 1px;
            background: linear-gradient(to right, transparent, #BAE6FD, transparent);
        }

        .photo-section-text {
            font-size: 12px;
            color: #64748B;
            font-weight: 500;
            letter-spacing: 2px;
            white-space: nowrap;
            padding: 0 4px;
        }
    }

    .photo-upload-row {
        display: flex;
        gap: 32px;
        padding: 0 4px 12px;
    }

    .photo-upload-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .photo-label {
            font-size: 13px;
            color: #475569;
            font-weight: 500;
            margin-bottom: 10px;
            text-align: center;

            &.required-label::before {
                content: "* ";
                color: #F56C6C;
                font-weight: 700;
            }
        }
    }
}
</style>

/* 非 scoped：dialog 使用 append-to-body 移出组件 DOM，scoped 选择器无法穿透，用 custom-class 在全局作用域覆盖 */
<style lang="scss">
.apply-job-dialog {
    /* 标签折行时：紧凑行高 + flex 垂直居中（排除 label-position=top 的表单） */
    %form-item-flex {
        .el-form-item {
            display: flex;
            align-items: center;
        }
        .el-form-item__label {
            float: none !important;
            flex-shrink: 0;
            line-height: 1.2 !important;
        }
        .el-form-item__content {
            margin-left: 0 !important;
            flex: 1;
            min-width: 0;
        }
    }

    /* base_form：基本信息网格 */
    .base-fields-grid {
        @extend %form-item-flex;
    }

    /* 子组件（education_card / work_card / family_card）：
       排除 label-position=top 的 other_form（会带 el-form--label-top 类） */
    .el-form:not(.el-form--label-top) .model-box-cont-item {
        @extend %form-item-flex;
    }
}
</style>
